<template>
	<div class="address-view right_auth">
        <div class="block block1">
            <p class="title">寄送地址</p>
            <table style="width: 935px;">
                <colgroup>
                    <col style="width: 300px;">
                    <col style="width: 200px;">
                    <col style="width: 500px;">
                    <col style="width: 200px;">
                </colgroup>
                <thead>
                    <tr>
                        <td>收件人姓名</td>
                        <td>电话号码</td>
                        <td>地址</td>
                        <td style="text-align: right;">操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in addressList">
                        <td>{{item.receiverName}}</td>
                        <td>{{item.userPhone}}</td>
                        <td> {{item.userAdd}}</td>
                        <td style="text-align: right;">
                            <a class="type to_default" v-if="item.haveDefault != 2" @click="setDefault(item,1)">设为默认</a>
                            <a class="type default" v-show="item.haveDefault == 2">默认地址</a>
                            <span class="opra" @click="updateAddress(item)">修改</span>  |
                            <span class="opra" @click="deleteAddress(item,$event)">删除</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="add" v-show="addressList.length < 5" @click="addAddress">新增地址<i></i></div>
        </div>
        <div class="block block2">
            <p class="title">发票信息管理</p>
            <ul class="invoice" v-for="item in invoiceList">
                <li>
                    <ul class="info_ul">
                        <li><span>发票抬头：</span> {{item.invoiceTitle}}</li>
                        <li><span>发票类型：</span> {{options._invoiceType[item.invoiceType]}}</li>
                        <li><span>纳税人识别号：</span> {{item.identifyNumber}}</li>
                        <li><span>注册电话：</span> {{item.regPhone}}</li>
                        <li><span>开户银行：</span> {{item.regBank}}</li>
                        <li><span>银行号码：</span> {{item.bankNumber}}</li>
                        <li><span>注册地址：</span> {{item.regAddress}}</li>
                    </ul>
                </li>
                <li class="invoice-info">
                    <a class="btn" style="color: green" @click="updateInvoice(item,$event)">修改</a>
                    <a class="btn" style="color: red"   @click="deleteInvoice(item,$event)">删除</a>
                    <a class="btn mark" v-show="item.haveDefault != 2" @click="setDefault(item,2,$event)">设为默认</a>
                    <a class="mark" v-show="item.haveDefault == 2">默认发票</a>
                </li>
            </ul>
            <div style="width: 105px;" class="add" v-show="invoiceList.length < 5"  @click="addInvoice">新增发票信息 <i></i></div>
        </div>
        <!-- 新增地址 -->
        <add-address ref="addressCtrl" @on-success="getAddressList"></add-address>
        <!-- 新增发票 -->
        <add-invoice ref="invoceCtrl"  @on-success="getInvoiceList"></add-invoice>
	</div>
</template>

<script type="es6">
  import { mapState, mapActions , mapGetters} from 'vuex'
  import { util } from '../service/util'
  import addAddress from '../components/addAddress'
  import addInvoice from '../components/addInvoice'
  
  let API = util.api([
      'ADDUSERADDRESS',
      // 用户查询地址
      'GETADDRESSBYUSERID',
      // 用户查询发票信息
      'GETUSERINVOICEBYUSERID',
      // 更新地址
      'UPDATEUSERADDRESS',
      // 更新发票模版
      'UPDATEUSERINVOICE',
      // 删除地址
      'DELETEUSERADDRESS',
      // 删除模版
      'DELETEUSERINVOICEBYID'
    ])
	export default {
      name: 'address-view',
      components: { addAddress,addInvoice},
      data () {
        return {
          pen:false,
          value: '',
          // 地址列表
          addressList: [],
          // 发票列表
          invoiceList: [],
        }
      },
      computed: {
        ...mapState({
            userInfo: state => state.common.userInfo,
            options:  state => state.common.options
          }),
      },
      methods: {
        // 触发更新地址
        updateAddress(item) {
          this.$refs.addressCtrl.doUpdate(item);
        },
        updateInvoice(item) {
          this.$refs.invoceCtrl.doUpdate(item);
        },
        // 触发新增地址
        addAddress() {
          this.$refs.addressCtrl.doAdd();
        },
        addInvoice() {
          this.$refs.invoceCtrl.doAdd();
        },
        // 触发删除
        deleteAddress(item) {
          util.confirm.select('确认操作','确认删除地址？', () => {
            util.kAjax(API.DELETEUSERADDRESS, { id:item.id }, res => {
              this.getAddressList();
            })
          })
        },
        deleteInvoice(item) {
          util.confirm.select('确认操作','确认删除发票模版？', () => {
            util.kAjax(API.DELETEUSERINVOICEBYID, { id:item.id }, res => {
              this.getInvoiceList();
            })
          })
        },
        // 设为默认
        setDefault(item, type) {
          let param = util.copy(item);
          let api = type == 1 ? API.UPDATEUSERADDRESS : API.UPDATEUSERINVOICE;
          let src = type == 1 ? this.addressList : this.invoiceList;
          param.haveDefault = 2;
          
          util.kAjax(api, param, res => {
            src.forEach( d => {
              d.haveDefault = 1;
            })
            item.haveDefault = 2;
          })
        },
        getAddressList() {
          util.kAjax(API.GETADDRESSBYUSERID,{},res => {

            this.addressList = res.data;
            if(!res.data.length){
              this.addAddress();
            }
          })
        },
        getInvoiceList() {
          util.kAjax(API.GETUSERINVOICEBYUSERID,{},res => {
            this.invoiceList = res.data;
            if(!res.data.length){
              this.addInvoice();
            }
          })
        },
      },
      created() {
        this.getAddressList();  
        this.getInvoiceList();
      }
    }
</script>

<style>
	/*.add-btn {
    display: inline-block;
    vertical-align: middle;
    font-weight: 700;
    padding: 0 14px;
    height: 28px;
    line-height: 28px;
    font-size: 14px;
    margin: 0 10px 0 0;
  }
  .invoice-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
  .invocie-info {
    position: absolute;
    right: 0;
    top: 0;
  }*/
</style>



// WEBPACK FOOTER //
// AddressView.vue?6cbfd36d